"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moment = require('moment-business-days');

var uniq = require('lodash/uniq');

var flatten = require('lodash/flatten');

var Shipment = require('./Shipment');

var ShipStationOrder = require('./ShipStation/ShipStationOrder');

var defaultShipmentsFunction = require('./defaultShipments');

var calculateClientShipDate = require('./calculateClientShipDate');

var calculateShipDate = require('./calculateShipDate');

var createNewShipStationOrder = require('./ShipStation');

var getOrderShippingOptions = require('./getOrderShippingOptions');

var estimateArrivalDateFunction = require('./estimateArrivalDate').estimateArrivalDate;

var estimateCustomerFacingArrivalDateFunction = require('./estimateArrivalDate').estimateCustomerFacingArrivalDate;

var qualifiesForFreeShippingFn = require('./qualifiesForFreeShipping');
/**
 * @namespace ShineShipping
 */


var ShineShipping = function ShineShipping() {
  var _instance;

  function init() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = opts;

    if (options.businessHolidays) {
      moment.defineLocale('en-shine', _objectSpread({
        parentLocale: 'en'
      }, options.businessHolidays));
    }
    /**
         * @param {Order} order
         * @param {*} userOpts
         * @returns {Array<Shipment>}
         */


    function defaultShipments(order, userOpts) {
      return defaultShipmentsFunction(order, userOpts, options);
    }

    function defaultShipmentsCollated(order, userOpts) {
      var shipments = defaultShipmentsFunction(order, userOpts, options);
      var collated_shipments = {};
      shipments.forEach(function (shipment) {
        var designation = shipment.designation;
        collated_shipments[designation] = shipment;
      });
      return collated_shipments;
    }

    function updateOptions() {
      var newOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      options = newOpts;
    }

    var shipments = {
      make: function make(params) {
        return new Shipment(params);
      }
    };
    var shipStationOrders = {
      make: function make(params) {
        return new ShipStationOrder(params);
      }
    };

    function createShipStationOrder(shipment, orderNumber) {
      return createNewShipStationOrder(shipment, orderNumber, options);
    }

    function getWarehouse(warehouseId) {
      var warehouses = options.warehouses;

      var _Object$keys$map$filt = Object.keys(warehouses).map(function (key) {
        return warehouses[key];
      }).filter(function (_ref) {
        var id = _ref.warehouseId;
        return id === warehouseId;
      }),
          _Object$keys$map$filt2 = _slicedToArray(_Object$keys$map$filt, 1),
          warehouse = _Object$keys$map$filt2[0];

      return warehouse;
    }

    function getService(code) {
      var service;
      options.services.forEach(function (obj) {
        if (obj.code === code) {
          service = obj;
        }
      });
      return service;
    }

    function getTrackingURL(carrierCode, trackingNumber) {
      return options.trackingURLs[carrierCode] + trackingNumber;
    }

    function getServices(carrierCode) {
      return options.services.filter(function (obj) {
        return obj.carrierCode === carrierCode;
      });
    }

    function getPackage(code) {
      var pakage;
      options.packages.forEach(function (obj) {
        if (obj.code === code) {
          pakage = obj;
        }
      });
      return pakage;
    }

    function getPackages(carrierCode) {
      return options.packages.filter(function (obj) {
        return obj.carrierCode === carrierCode;
      });
    }

    function getShippingOptions(order) {
      return getOrderShippingOptions(order, options);
    }

    function qualifiesForFreeShipping(order) {
      return qualifiesForFreeShippingFn(order, options);
    }

    function estimateArrivalDate(shipment, order) {
      return estimateArrivalDateFunction(shipment, order, options);
    }

    function estimateCustomerFacingArrivalDate(shipment, order) {
      return estimateCustomerFacingArrivalDateFunction(shipment, order, options);
    }

    function parseShippingServiceFromVersionZero(shipping_type, order_date) {
      // get the text from before the colon.
      // e.g. "Standard Shipping: $8.95" => "Standard Shipping"
      var regex_matching = shipping_type.match(/:/);
      var service = '';

      if (regex_matching && regex_matching.index) {
        service = shipping_type.slice(0, regex_matching.index);
      } // we added "Standard Shipping" to mean Priority Mail at one point.


      if (new Date(order_date) < new Date('2019-12-18T16:00:00.000Z') && service === 'Standard Shipping') {
        return 'Priority Mail';
      } // check the result against the possible services by title


      var valid_services = uniq(flatten(Object.values(options.orders.services)).map(function (_ref2) {
        var title = _ref2.title;
        return title;
      }));

      if (!valid_services.includes(service)) {
        console.error("".concat(service, " is not a valid shipping service"));
        return null;
      }

      return service;
    }

    return {
      shipments: shipments,
      createShipStationOrder: createShipStationOrder,
      makeShipStationOrder: createShipStationOrder,
      shipStationOrders: shipStationOrders,
      updateOptions: updateOptions,
      options: options,
      defaultShipments: defaultShipments,
      defaultShipmentsCollated: defaultShipmentsCollated,
      calculateClientShipDate: calculateClientShipDate,
      calculateShipDate: calculateShipDate,
      getWarehouse: getWarehouse,
      getService: getService,
      getServices: getServices,
      getPackage: getPackage,
      getPackages: getPackages,
      getTrackingURL: getTrackingURL,
      getShippingOptions: getShippingOptions,
      qualifiesForFreeShipping: qualifiesForFreeShipping,
      parseShippingServiceFromVersionZero: parseShippingServiceFromVersionZero,
      estimateArrivalDate: estimateArrivalDate,
      estimateCustomerFacingArrivalDate: estimateCustomerFacingArrivalDate
    };
  }

  return {
    /**
         * initialize
         * @param {*} opts
         * @instance
         * @example
         * import { ShineShipping } from 'shine-products-v2';
         * ShineShipping.initialize(opts);
         */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
         * SINGLETON INSTANCE
         * @instance
         * @example
         * import { ShineShipping } from 'shine-products-v2';
         * ShineShipping.instance()
         */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();

module.exports = ShineShipping;